<template lang="pug">
v-card(:outlined="url!=''" :flat="url==''")
  .embed-frame(:style="style")
    iframe(:src="url" width="800" height="600" frameborder="0" allowFullScreen="true")
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ""
    },
    width: Number,
    aspect: {
      type: Number,
      default: 16 / 9
    },
    xOffset: {
      type: Number,
      default: 0
    },
    yOffset: {
      type: Number,
      default: 0
    }
  },
  computed: {
    adjustedAspect () {
      if(!this.width)
        return 1 / this.aspect
      let height = (this.width - this.xOffset) / this.aspect + this.yOffset
      return height / this.width
    },
    style () {
      return `padding-top:${100 * this.adjustedAspect}%`
    }
  }
}
</script>

<style lang="stylus">
.embed-frame
  position: relative
  height: 0
  padding-top: 56.25%
  overflow: hidden
  iframe
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
</style>